import React, { Component } from 'react'
import CreatableSelect from 'react-select/creatable';
import styled from 'styled-components'

let ErrorMsg = styled.div`
  color: red
`;

class CreatableSelectField extends Component {
  handleChange = value => {
    const { onChange, name } = this.props

    onChange(name, value)
  }

  handleBlur = () => {
    const { onBlur, name } = this.props

    onBlur(name, true)
  }

  render() {
    const {
      id,
      name,
      label,
      placeholder,
      options,
      value,
      isMulti,
      isDisabled,
      touched,
      error,
      errorObject,
      errorList,
      isClearable,
      backspaceRemovesValue,
    } = this.props

    return (
      <div className="input-field-wrapper">
        {label && (
          <h6 className="input-label" htmlFor={name} error={error}>
            {label}
          </h6>
        )}

        <CreatableSelect
          id={id}
          placeholder={placeholder}
          options={options}
          value={value}
          onChange={this.handleChange}
          onBlur={this.handleBlur}
          touched={touched}
          error={error}
          isMulti={isMulti}
          isDisabled={isDisabled}
          isClearable={isClearable}
          backspaceRemovesValue={backspaceRemovesValue}
          components={{ ClearIndicator: null }}
        />

        {touched && error ? <ErrorMsg>{error}</ErrorMsg> : null}
        {touched && errorObject ? <ErrorMsg>{errorObject.value}</ErrorMsg> : null}
        {touched && errorList && Array.isArray(errorList) ? errorList.map(e => <ErrorMsg>{e && e.value}</ErrorMsg>) : null}
        {touched && errorList && !Array.isArray(errorList) ? <ErrorMsg>{errorList}</ErrorMsg> : null}
      </div>
    )
  }
}

export default CreatableSelectField
